import { Col, Row, Select, SelectProps } from 'antd';

import styles from './DoughnutBoxTitleWithComparator.module.css';

interface DoughnutBoxTitleWithComparatorProps extends SelectProps {
  title?: string;
}

const DoughnutBoxTitleWithComparator: React.FC<DoughnutBoxTitleWithComparatorProps> = ({
  title,
  ...props
}) => {
  return (
    <Col>
      <Row justify="center">{title || 'Comparar com outro arquétipo'}</Row>
      <Row justify="center">
        <Select className={styles.title__select} allowClear {...props} />
      </Row>
    </Col>
  );
};

export default DoughnutBoxTitleWithComparator;
